import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { toggleContactModalState } from '../../../ducks/contact.duck';
import { getFAQLinks } from '../../../marketplace-links';
import { openCookieSettings } from '../../../util/consent/consentUI';
import BoxSeparator from '../../BoxSeperator/BoxSeparator';
import Link from '../../Links/Link/Link';

const buttonLinkStyle = { justifyContent: 'space-between' };

const SectionHelpComponent = ({ onClose }) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const handleSupportContactClick = (event) => {
    event.preventDefault();
    dispatch(toggleContactModalState(true));
  };

  const handleCookieSettingsClick = () => {
    // Close the menu first so the settings dialog isn't stacked under it.
    onClose();
    openCookieSettings();
  };

  return (
    <>
      <BoxSeparator />
      <Stack px={4}>
        <Typography gutterBottom variant="h5">
          <FormattedMessage id="AccountBottomBarBox.help" />
        </Typography>
        <Button
          color="secondary"
          fullWidth
          href={getFAQLinks(intl.locale, 'customer')}
          sx={buttonLinkStyle}
          target="_self"
        >
          <FormattedMessage id="Footer.toFAQPageGuest" />
          <ChevronRightIcon color="secondary" />
        </Button>
        <Button
          color="secondary"
          fullWidth
          href={getFAQLinks(intl.locale, 'host')}
          sx={buttonLinkStyle}
          target="_self"
        >
          <FormattedMessage id="Footer.toFAQPageHost" />
          <ChevronRightIcon color="secondary" />
        </Button>
        <Button
          color="secondary"
          fullWidth
          onClick={handleSupportContactClick}
          sx={buttonLinkStyle}
        >
          <FormattedMessage id="AccountBottomBarBox.contactSupport" />
          <ChevronRightIcon color="secondary" />
        </Button>

        <Button
          color="secondary"
          component={Link}
          onClick={onClose}
          sx={buttonLinkStyle}
          to={{ name: 'StoryblokPage', params: { slug: 'terms-of-service' } }}
        >
          <FormattedMessage id="AccountBottomBarBox.termsOfUse" />

          <ChevronRightIcon color="secondary" />
        </Button>
        <Button
          color="secondary"
          component={Link}
          onClick={onClose}
          sx={buttonLinkStyle}
          to={{ name: 'StoryblokPage', params: { slug: 'privacy-policy' } }}
        >
          <FormattedMessage id="AccountBottomBarBox.privacyPolicy" />
          <ChevronRightIcon color="secondary" />
        </Button>
        <Button color="secondary" fullWidth onClick={handleCookieSettingsClick} sx={buttonLinkStyle}>
          <FormattedMessage id="Footer.cookieSettings" />
          <ChevronRightIcon color="secondary" />
        </Button>
        <Button
          color="secondary"
          component={Link}
          onClick={onClose}
          sx={buttonLinkStyle}
          to={{ name: 'StoryblokPage', params: { slug: 'impressum' } }}
        >
          <FormattedMessage id="AccountBottomBarBox.impressum" />
          <ChevronRightIcon color="secondary" />
        </Button>
      </Stack>
    </>
  );
};

SectionHelpComponent.displayName = 'SectionHelp';
const SectionHelp = memo(SectionHelpComponent);
export default SectionHelp;
